export default "__VITE_ASSET__704e646d__"